import React, { useState } from 'react';
import { ArrowRight, Send, Calendar } from 'lucide-react';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Kontakt = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      await axios.post(`${API}/contact`, {
        name: formData.name,
        email: formData.email,
        company: formData.company,
        message: formData.message
      });

      setSubmitStatus('success');
      setFormData({ name: '', email: '', company: '', message: '' });
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="kontakt-page">
      {/* Header Section */}
      <section className="kontakt-header-section">
        <div className="section-container">
          <h1 className="kontakt-main-heading">{t('contactHeading')}</h1>
          <p className="kontakt-intro-text">
            {t('contactIntro')}
          </p>
        </div>
      </section>

      <div className="kontakt-sections-wrapper">
        {/* Section 1 - Boka ett samtal */}
        <section className="kontakt-section">
          <div className="section-container">
            <div className="kontakt-card">
              <div className="kontakt-icon-container">
                <Calendar size={40} />
              </div>
              
              <h2 className="kontakt-section-heading">{t('contactBookHeading').toUpperCase()}</h2>
              <p className="kontakt-section-text">
                {t('contactBookText')}
              </p>
              
              <a 
                href="https://calendly.com/partsnap-info/15min" 
                target="_blank" 
                rel="noopener noreferrer"
                className="cta-button kontakt-cta-button"
              >
                <span>{t('contactBookButton').toUpperCase()}</span>
                <ArrowRight className="button-icon" size={20} />
              </a>
            </div>
          </div>
        </section>

        {/* Section 2 - Skicka ett meddelande */}
        <section className="kontakt-section">
          <div className="section-container">
            <div className="kontakt-card">
              <div className="kontakt-icon-container">
                <Send size={40} />
              </div>
              
              <h2 className="kontakt-section-heading">{t('contactFormHeading').toUpperCase()}</h2>
              <p className="kontakt-section-text">
                {t('contactIntro')}
              </p>
              
              <form className="kontakt-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name" className="form-label">{t('contactFormName')} *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="form-input"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder={t('contactFormNamePlaceholder')}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email" className="form-label">{t('contactFormEmail')} *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-input"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder={t('contactFormEmailPlaceholder')}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="company" className="form-label">{t('contactFormCompany')}</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    className="form-input"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder={t('contactFormCompanyPlaceholder')}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message" className="form-label">{t('contactFormMessage')} *</label>
                  <textarea
                    id="message"
                    name="message"
                    className="form-textarea"
                    rows="6"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder={t('contactFormMessagePlaceholder')}
                    required
                  ></textarea>
                </div>

                {submitStatus === 'success' && (
                  <div className="form-message success-message">
                    {t('contactFormSuccess')}
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="form-message error-message">
                    {t('contactFormError')}
                  </div>
                )}

                <button 
                  type="submit" 
                  className="cta-button kontakt-submit-button"
                  disabled={isSubmitting}
                >
                  <span>{isSubmitting ? t('contactFormSubmitting').toUpperCase() : t('contactFormSubmit').toUpperCase()}</span>
                  <Send className="button-icon" size={20} />
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Kontakt;
